import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MediaModule } from '@spartacus/storefront'
import { CentralizedButtonModule } from './shared/centralized-button/centralized-button.module'
import { ImageModalModule } from './shared/image-modal/image-modal.module'
import { VideoModalModule } from './shared/video-modal/video-modal.module'
import { CmsComponentsBaseModule } from './cms-components-base.module'
import { CampusModalModule } from './shared/campus-modal/campus-modal.module'
import { DisclaimerModalModule } from './shared/disclaimer-modal/disclaimer-modal.module'
import { CountryBarModule } from './country-bar/country-bar.module'
import { CenteredTextFeatureModule } from './centered-text/centered-text-feature.module'
import {
  AccordionMainContentFeatureModule
} from './accordion/accordion-main-content-container/accordion-main-content-feature.module'
import { OpenPanelRootModule } from './open-panel/open-panel-containers/open-panel-root.module'
import { BulletPointsFeatureModule } from './bullet-points/bullet-points-feature.module'
import { CellIsolationSpecialFeatureModule } from './cell-isolation-special/cell-isolation-special-feature.module'
import { CmsProductListFeatureModule } from './cms-product-list/cms-product-list-feature.module'
import { ColumnsSpecialFeatureModule } from './columns-special/columns-special-feature.module'
import { DisclaimerFeatureModule } from './disclaimer/disclaimer-feature.module'
import { FullWidthGalleryFeatureModule } from './full-width-gallery/full-width-gallery-feature.module'
import { FullWidthHeadlineFeatureModule } from './full-width-headline/full-width-headline-feature.module'
import {
  FullWidthIconNavigationFeatureModule
} from './full-width-icon-navigation/full-width-icon-navigation-feature.module'
import { FullWidthImageTextBoxFeatureModule } from './full-width-image-text-box/full-width-image-text-box-feature.module'
import { FullWidthInlineVideoFeatureModule } from './full-width-inline-video/full-width-inline-video-feature.module'
import { FullWidthOrderBoxFeatureModule } from './full-width-order-box/full-width-order-box-feature.module'
import { GalleryFeatureModule } from './gallery/gallery-feature.module'
import { HeaderRootModule } from './header/header-root.module'
import { SubsectionHeadlineFeatureModule } from './subsection-headline/subsection-headline-feature.module'
import { IFrameFeatureModule } from './i-frame/i-frame-feature.module'
import { IntroTextFeatureModule } from './intro-text/intro-text-feature.module'
import { LegalBoxFeatureModule } from './legal-box/legal-box-feature.module'
import { LocationsMapFeatureModule } from './locations-map/locations-map-feature.module'
import { MacsHandbookRootModule } from './macs-handbook/macs-handbook-root.module'
import { MacsIqViewFeatureModule } from './macs-iq-view/macs-iq-view-feature.module'
import { MacsMapFeatureModule } from './macs-map/macs-map-feature.module'
import { MacsimaArtToolFeatureModule } from './macsima-art-tool/macsima-art-tool-feature.module'
import { PlainTeaserSplitFeatureModule } from './plain-teaser-split/plain-teaser-split-feature.module'
import { PortfolioOverviewFeatureModule } from './portfolio-overview/portfolio-overview-feature.module'
import {
  RelatedProductsAndFamiliesListFeatureModule
} from './related-products-and-families-list/related-products-and-families-list-feature.module'
import { SplitContainerFeatureModule } from './split-container/split-container-feature.module'
import { TabBoxFeatureModule } from './tab-box/tab-box-feature.module'
import { TeaserRootModule } from './teaser/teaser-root.module'
import { TestimonialContainerFeatureModule } from './testimonial-container/testimonial-container-feature.module'
import { TilesFeatureModule } from './tiles/tiles-feature.module'
import { TopicOverviewFeatureModule } from './topic-overview/topic-overview-feature.module'
import { UspRowFeatureModule } from './usp-row/usp-row-feature.module'
import { WebformsFormFeatureModule } from './webforms-form/webforms-form-feature.module'
import {
  EditorialPdpAccordionContainerFeatureModule
} from './editorial-pdp-accordion-container/editorial-pdp-accordion-container-feature.module'
import { ContactBoxInCartFeatureModule } from './contact-box/contact-box-in-cart/contact-box-in-cart-feature.module'
import {
  ContactBoxNavigationFeatureModule
} from './contact-box/contact-box-navigation/contact-box-navigation-feature.module'
import {
  ContactBoxTechnicalFeatureModule
} from './contact-box/contact-box-technical/contact-box-technical-feature.module'
import { ContactBoxFullFeatureModule } from './contact-box/contact-box-full/contact-box-full-feature.module'
import { CongressContainerFeatureModule } from './congress-container/congress-container-feature.module'
import { SharedComponentsRootModule } from './shared/shared-components-root.module'
import { SearchResultsFeatureModule } from './search-results/search-results-feature.module'
import { ColorContainerRootModule } from './color-container/color-container-root.module'
import { WidgetFeatureModule } from './widget/widget-feature.module'
import { VideoSearchFeatureModule } from './video-search/video-search-feature.module'
import { TeaserWithBubblesFeatureModule } from './teaser/teaser-with-bubbles/teaser-with-bubbles-feature.module'
import { CmsSearchFeatureModule } from './cms-search/cms-search-feature.module'
import { FreshchatWebWidgetFeatureModule } from './fresh-chat/freshchat-web-widget/freshchat-web-widget-feature.module'
import { LiveChatFeatureModule } from './fresh-chat/live-chat/live-chat-feature.module'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { HttpRequestInterceptorService } from '../services/http-request-interceptor/http-request-interceptor.service'
import { UcBlockedContentReplacerModule } from './uc-blocked-content-replacer/uc-blocked-content-replacer.module'
import { InfographicFeatureModule } from './infographic/infographic-feature.module'
import { ConsentModalModule } from './shared/consent-modal/consent-modal.module'
import { ImageCarouselModalModule } from './shared/image-carousel-modal/image-carousel-modal.module'
import { ProductFinderFeatureModule } from './product-finder/product-finder-feature.module'

@NgModule({
  imports: [
    CmsComponentsBaseModule,
    RouterModule,
    MediaModule,
    HeaderRootModule,
    TeaserWithBubblesFeatureModule,
    ContactBoxInCartFeatureModule,
    ContactBoxNavigationFeatureModule,
    ContactBoxTechnicalFeatureModule,
    ContactBoxFullFeatureModule,
    UspRowFeatureModule,
    MacsMapFeatureModule,
    CongressContainerFeatureModule,
    ColorContainerRootModule,
    OpenPanelRootModule,
    CentralizedButtonModule,
    VideoModalModule,
    ImageModalModule,
    ConsentModalModule,
    AccordionMainContentFeatureModule,
    SubsectionHeadlineFeatureModule,
    IntroTextFeatureModule,
    TeaserRootModule,
    CenteredTextFeatureModule,
    SplitContainerFeatureModule,
    LegalBoxFeatureModule,
    PortfolioOverviewFeatureModule,
    BulletPointsFeatureModule,
    IFrameFeatureModule,
    MacsHandbookRootModule,
    CampusModalModule,
    CmsProductListFeatureModule,
    TopicOverviewFeatureModule,
    FullWidthImageTextBoxFeatureModule,
    TilesFeatureModule,
    TabBoxFeatureModule,
    GalleryFeatureModule,
    DisclaimerFeatureModule,
    DisclaimerModalModule,
    FullWidthInlineVideoFeatureModule,
    ColumnsSpecialFeatureModule,
    FullWidthGalleryFeatureModule,
    CountryBarModule,
    WebformsFormFeatureModule,
    MacsimaArtToolFeatureModule,
    FullWidthOrderBoxFeatureModule,
    CellIsolationSpecialFeatureModule,
    PlainTeaserSplitFeatureModule,
    LocationsMapFeatureModule,
    MacsIqViewFeatureModule,
    EditorialPdpAccordionContainerFeatureModule,
    FullWidthHeadlineFeatureModule,
    RelatedProductsAndFamiliesListFeatureModule,
    FullWidthIconNavigationFeatureModule,
    LiveChatFeatureModule,
    TestimonialContainerFeatureModule,
    SharedComponentsRootModule,
    SearchResultsFeatureModule,
    WidgetFeatureModule,
    VideoSearchFeatureModule,
    CmsSearchFeatureModule,
    FreshchatWebWidgetFeatureModule,
    UcBlockedContentReplacerModule,
    InfographicFeatureModule,
    ImageCarouselModalModule,
    ProductFinderFeatureModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptorService,
      multi: true
    },
  ]
})
export class CmsComponentsModule {
}
